// extracted by mini-css-extract-plugin
module.exports = {"title":"IntroTitle_title__2yDAF","text":"IntroTitle_text__3lsp3"};